/* lp-viewport.js — hand the scroll position across Horizon's scroll-container breakpoint.

   Horizon scrolls the DOCUMENT below 990px and a full-height .page-wrapper (body overflow:hidden) at
   990px and above. Cross that line with the page scrolled — an iPad rotating from portrait to landscape,
   a window dragged wider, the dev's resize test on 22 Sep 2026 — and the offset stays on the element that
   no longer scrolls: the document is left scrolled past the wrapper and the viewport shows nothing. This
   moves the offset to whichever element scrolls now, both directions. window.lpViewportSync is exposed so
   it can be exercised without a real resize. */
(function () {
  'use strict';
  if (!window.matchMedia) return;
  var mq = matchMedia('(min-width: 990px)');
  function sync(desktop) {
    var pw = document.querySelector('.page-wrapper');
    if (!pw) return;
    var docY = window.scrollY || document.documentElement.scrollTop || 0;
    if (desktop) {
      /* the wrapper scrolls now; anything left on the document would show as a blank page */
      if (docY > 0) { window.scrollTo(0, 0); requestAnimationFrame(function () { pw.scrollTop = docY; }); }
    } else {
      var pwY = pw.scrollTop || 0;
      if (pwY > 0) { pw.scrollTop = 0; requestAnimationFrame(function () { window.scrollTo(0, pwY); }); }
    }
  }
  window.lpViewportSync = function () { sync(mq.matches); };
  var onChange = function (e) { sync(e.matches); };
  if (mq.addEventListener) mq.addEventListener('change', onChange); else mq.addListener(onChange);
  /* a restored scroll position on load can land on the wrong element too */
  if (document.readyState === 'complete') sync(mq.matches); else window.addEventListener('load', function () { sync(mq.matches); });
})();
